<template>
	<div
		class="pdf-initials"
		:class="{
			'pdf-initials-signed': overlay.initials.isSigned,
			'pdf-initials-cosigner': overlay.initials.personType == 2,
		}"
		:style="{
			height: '60px',
			width: '7%',
			zIndex: !overlay.initials.isSigned ? (overlay.initials.personType == 1 ? 2 : 1) : 0,
		}"
		@click="sign()"
	>
		<div
			class="sign-name-container"
			v-if="!overlay.initials.isSigned"
		>
			<div :style="{ textAlign: 'center' }">Click For Initials</div>
		</div>
		<img
			class="img-initials"
			v-if="overlay.initials.isSigned"
			:src="displayImage"
		/>
	</div>
</template>
<script lang="ts">
	export interface IPDFInitialsProps {
		overlay: IDocumentOverlay;
		pdfRef: HTMLElement;
	}
</script>
<script setup lang="ts">
	import { computed, inject } from 'vue';
	import { IDocumentOverlay } from '@core/classes/Paperwork/DocumentOverlay';
	import { Emitter } from 'mitt';
	import { getPersonSigningFromOverlay } from '@core/helpers/esign-helper';
	import settings from 'settings';
	import { useFIMenuForCustomerMeetingStore } from '@core/stores/FIMenuForCustomerMeetingStore';

	const fimenuStore = useFIMenuForCustomerMeetingStore();
	const fimenu = computed(() => fimenuStore.fimenu);

	const $meetingHub = inject<any>('$meetingHub', null);
	const EventBus = inject<Emitter<any>>('EventBus', null);

	//#region PROPS
	const { overlay, pdfRef } = defineProps<IPDFInitialsProps>();
	//#endregion

	//#region COMPUTED
	const displayImage = computed(() => {
		const initialsIdToApply = overlay.initials?.signedInitialsId;
		if (initialsIdToApply) {
			return `${settings.appDomain}/api/SaturnWeb/getSignatureImg?&meetingCode=${$meetingHub.code}&accessKey=${$meetingHub.accessKey}&userId=${$meetingHub.userId}&imgId=${initialsIdToApply}`;
		}
		return null;
	});

	//#endregion

	async function sign() {
		if (!overlay.initials.isSigned) {
			const personSigning = getPersonSigningFromOverlay(overlay.signatureMapping.signerId, overlay, fimenu.value);
			console.log('signing initials', personSigning, overlay);
			if (personSigning.currentInitialsId) {
				EventBus.emit('clickedToSign', overlay);
			} else {
				// since we dont have a signature fo this signature, open up the signature pad
				EventBus.emit('showSignaturePad', {
					postFunction: onSignaturePadSigned,
					signerId: overlay.signatureMapping.signerId,
				});
			}
		}
	}
	async function onSignaturePadSigned(signature: string, initials: string, signatureData: any, initialsData: any) {
		if (signature && initials) {
			const signatureImages = {
				signatureImgB64: signature,
				initialsImgB64: initials,
			};

			EventBus.emit('signatureReceived', {
				signatureImages,
				overlay,
				signatureData,
				initialsData,
			});
		}
	}
</script>

<style></style>
